import { getDocument, getWindow } from 'ssr-window';
import Config from '@/config/index';
const window = getWindow();
const document = getDocument();
const loadThirdPartyScripts = () => {
    /* eslint-disable */
    if (Config.googleAnalyticsEnabled) {
        const gaScript = document.createElement('script');
        gaScript.async = true;
        gaScript.src =
            'https://www.googletagmanager.com/gtag/js?id=' +
                Config.googleAnalyticsAccount;
        document.head.appendChild(gaScript);
        gaScript.onload = () => {
            window.dataLayer = window.dataLayer || [];
            window.gtag = function gtag() {
                window.dataLayer.push(arguments);
            };
            window.gtag('js', new Date());
            window.gtag('config', Config.googleAnalyticsAccount);
        };
    }
    else {
        // GoogleTagManager
        (function (w, d, s, l, i) {
            w[l] = w[l] || [];
            w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
            var f = d.getElementsByTagName(s)[0], j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : '';
            j.async = true;
            j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
            f.parentNode.insertBefore(j, f);
        })(window, document, 'script', 'dataLayer', Config.gtmAccount);
    }
    /* eslint-enable */
};
export default loadThirdPartyScripts;
